<template>
  <span>
    <slot v-bind="{ onClickUploadButton, loading: loading || importfileloading }">
      <v-btn
        :loading="loading || importfileloading"
        outline
        color="blue"
        @click="onClickUploadButton"
      >
        <em class="fas fa-file-upload mr-2" />{{ $t('import') }}
      </v-btn>
    </slot>
    <input
      :id="'csvUploadCentralHr'"
      :key="`file__${keyupload}`"
      v-validate="'mimes:text/xlsx'"
      type="file"
      class="form-control-file pt-2"
      name="csvUploadCentralHr"
      data-vv-as="File"
      accept=".xlsx"
      style="overflow: hidden; position: fixed; width: 1px; height: 1px; z-index: -1; opacity: 0"
      @input="onFileChange($event)"
    />
  </span>
</template>

<script>
import * as XLSX from 'xlsx'
import moment from 'moment'
export default {
  props: {
    noraw: {
      type: Boolean,
      default: false
    },
    loading: {
      default: false
    },
    useFormatDate: {
      default: false
    },
    formatDate: {
      default: 'YYYY-MM-DD HH:mm'
    }
  },
  data() {
    return {
      importfileloading: false,
      keyupload: 0
    }
  },
  methods: {
    onClickUploadButton() {
      document.getElementById('csvUploadCentralHr').click()
    },
    onFileChange(event) {
      let vm = this
      vm.importfileloading = true
      let files = event.target.files || event.dataTransfer.files
      var myFile = files[0]
      var reader = new FileReader()
      reader.onload = function (e) {
        var data = new Uint8Array(e.target.result)
        var workbook = XLSX.read(data, { type: 'array', cellDates: true })

        /* DO SOMETHING WITH workbook HERE */
        var result = []
        for (var sheet in workbook.Sheets) {
          if (vm.noraw) {
            var jsonresult = XLSX.utils.sheet_to_json(workbook.Sheets[sheet], {
              raw: false
            })
          } else {
            var jsonresult = XLSX.utils.sheet_to_json(workbook.Sheets[sheet])
          }
          jsonresult = jsonresult
            .filter((obj) => !Object.keys(obj).some((key) => key.startsWith('__EMPTY')))
            .map((obj) => {
              var objdata = obj
              for (const [key, value] of Object.entries(objdata)) {
                if (key == 'sale_price_effective_date') {
                  objdata[key] = objdata[key].replace('UTC', ' ')
                }
                if (
                  vm.useFormatDate &&
                  (typeof value.getMonth === 'function' || value instanceof Date)
                ) {
                  objdata[key] = moment(objdata[key]).format(vm.formatDate)
                }
              }

              return objdata
            })

          result.push(vm.trimObj(jsonresult))
        }
        vm.$emit('onChange', result)
        vm.keyupload++
        vm.importfileloading = false
        // vm.uploadExcel(result)
      }
      reader.readAsArrayBuffer(myFile)
    },
    trimObj(obj) {
      var vm = this
      if (!Array.isArray(obj) && typeof obj != 'object') return obj
      // console.log(obj)
      var result = Object.keys(obj).reduce(
        function (acc, key) {
          acc[key.trim()] = typeof obj[key] == 'string' ? obj[key].trim() : vm.trimObj(obj[key])
          return acc
        },
        Array.isArray(obj) ? [] : {}
      )

      return result
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/importxlsx.vue